import { render, staticRenderFns } from "./EduCourseZhiBo.vue?vue&type=template&id=b254d4fc&scoped=true"
import script from "./EduCourseZhiBo.vue?vue&type=script&lang=js"
export * from "./EduCourseZhiBo.vue?vue&type=script&lang=js"
import style0 from "./EduCourseZhiBo.vue?vue&type=style&index=0&id=b254d4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b254d4fc",
  null
  
)

export default component.exports